import type { PropsWithChildren } from 'react';

import { useAuth } from '@spotify/confidence-core-react';

import { useOnboardingSurvey } from '../../hooks/useOnboardingSurvey';
import { OnboardingSurvey } from '../OnboardingSurvey';

export const OnboardingSurveyGate = ({ children }: PropsWithChildren) => {
  const { orgName } = useAuth();
  const { status, isSaving, hasSaveError, saveAnswers } = useOnboardingSurvey();

  if (status === 'unanswered') {
    return (
      <OnboardingSurvey
        orgName={orgName}
        isSaving={isSaving}
        hasSaveError={hasSaveError}
        onSave={saveAnswers}
      />
    );
  }

  return <>{children}</>;
};
